import styled from 'styled-components';

export const DirectoryContainer = styled.div`
  width: 100%;
  display: block;
  flex-wrap: wrap;
  justify-content: space-between;

  .video-ad {
    position: relative;
    margin: 0 auto 48px;
  }
`;
